import React, { useEffect, useRef } from 'react'
import nouislider from 'nouislider'

import { FormField } from '@/components/forms/FormField'

import './Slider.scss'

export const Slider = ({
  label,
  field: { name, value },
  required,
  formikProps,
  disabled,
  ...props
}) => {
  const sliderContainerRef = useRef(null)

  const createSlider = () => {
    const sliderComponent = nouislider.create(sliderContainerRef.current, {
      start: [value.after || 0, value.before || 3660],
      connect: true,
      step: 60,
      keyboardSupport: true,
      format: {
        to: (value) => Math.round(value),
        from: (value) => Math.round(value),
      },
      tooltips: [
        {
          from: Number,
          to: (value) => {
            if (value === 0) return 'From beginning'

            return `From ${Math.round(value) / 60} minutes`
          },
        },
        {
          from: Number,
          to: (value) => {
            if (value === 3660) return 'To end of call'

            return `To ${Math.round(value) / 60} minutes`
          },
        },
      ],
      range: {
        min: 0,
        max: 3660,
      },
      // spreading props after so you can override whatever you need to if we re-use
      ...props,
    })

    sliderComponent.on('change', (range) => {
      formikProps.setFieldValue('trigger.after', range[0])
      formikProps.setFieldValue('trigger.before', range[1])
    })

    return sliderComponent
  }

  useEffect(() => {
    const slider = createSlider()

    return () => {
      if (slider) {
        slider.destroy()
      }
    }
  }, [])

  return (
    <FormField
      required={required}
      disabled={disabled}
      className={props.className}
      data-testid={`${name}-select`}
    >
      {label && <label htmlFor={name}>{label}</label>}
      <div
        ref={sliderContainerRef}
        className="form-slider"
        style={{ pointerEvents: disabled ? 'none' : 'auto' }}
      />
    </FormField>
  )
}
